/* eslint-disable no-console */
import React, { useState, useEffect, useCallback } from 'react';
import HeaderProfile from '../../components/header_Profile/header_Profile.index';
import styles from './../../pages/Clinical_Profile/Investigation_Diagnosis/investigation_diagnosis.module.css';
import { ThemeProvider,  Button,  Box,  Typography,} from '@mui/material';
import { theme } from '../../theme';
import { useTranslation } from 'react-i18next';
import PgtOrders from './pgtOrders';
import PgtResult from './PgtResult';
import { Patientv2 } from '../../types';
import { fetchViaProxy, initiateSSO2 } from './pgtaHelper';
import PgtOrderForm from './PgtOrderForm';
import Grid2 from '@mui/material/Grid2';
import { getButtonStates } from '../../utils/permissionService';

export default function PgtHome() {
  // const { t: tGeneral } = useTranslation('general');
  const { t: tPGT } = useTranslation('pgt_config');
  const [selectedPatient, setselectedPatient] = useState<Patientv2 | null>(null);

  
  const { canAdd } = getButtonStates('Lab', 'PGT', 'Order', 'female');
    
    
  const [activeTab, setActiveTab] = useState('Test');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showAddForm, setShowAddForm] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDatafromHeader = (data: any) => {
    // console.log('Selected Patient Data:', data);
    setselectedPatient(data);
  };
  
  const handleProgenesisLogin4 = useCallback(() => {
    // Prevent infinite redirect loop if token is already present
    const token = localStorage.getItem('progenesis_token');
    if (token) {
      // Already logged in, do not redirect again
      return;
    }

    const currentUrl = window.location.origin + window.location.pathname;
    initiateSSO2(currentUrl)
      .then((response) => {
        const { status, location, msg } = response;
        console.log('SSO response received:', response);
        // If status is ok, msg is empty, and location is present, open in new tab
        if (status === 'ok' && location && (msg === '' || msg === undefined)) {
          window.open(location, '_blank', 'noopener');
        } else if (msg === 'Already Authenticated' && location) {
          console.log(location);
        } else {
          console.warn(`Invalid SSO response. Reason: ${msg || 'Unknown'}`);
        }
      })
      .catch((error) => {
        console.error('SSO initiation failed:', error); 
      });
  }, []);

  
  // Called after login redirect with token
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    console.log('URLSearchParams:', params);
    const tokenFromRedirect = params.get('token'); 
    
    const authParam = params.get('auth');
    if (tokenFromRedirect) {
      localStorage.setItem('progenesis_token', tokenFromRedirect);
      // Clean the URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    console.log('authParam:', authParam);
    // If auth param is true, call fetchPhysicians
    if (authParam === 'true') {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      fetchPhysicians();
    }
    // Call login to Progenesis by default
    handleProgenesisLogin4();
  }, [handleProgenesisLogin4]);


  const fetchPhysicians = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('No token found. Please login to Progenesis first.');
      return;
    }
    fetchViaProxy('/api/v2/doctors', 'GET')
      .then((response) => {
        const { status, data } = response;
        if (status === 200 && data?.data) {
          console.log('Physicians fetched:', data.data);
        // setPhysicians(data.data); // Use if applicable
        } else {
          console.warn('Unexpected physician response:', response);
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch((err : any) => {
        console.error('Proxy request failed:', err);
      });
  };
  
  const handleAddOrders = () => {
    setShowAddForm(true);
  };
  
  return (
    <ThemeProvider theme={theme}>
      <div>
        <HeaderProfile onData={handleDatafromHeader} />
        <Grid2 sx={{ my: 2, px: 3, mt: 6 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" fontWeight="bold">
              {tPGT('pgtTitle')}
            </Typography>
            {/* <Button onClick={handleProgenesisLogin4} variant="outlined">Login to Progenesis</Button> */}
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {/* Left side: Order and PGT Result buttons */}
            <div className={styles.tabs}>
              <button
                className={styles.tab}
                style={{
                  
                  width: '150px',
                  backgroundColor: activeTab === 'Test' ? 'white' : 'transparent',
                  color: activeTab === 'Test' ? '#f65e39' : 'black',
                  boxShadow: activeTab === 'Test' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '',
                }}
                onClick={() => setActiveTab('Test')}
              >
                {tPGT('order')} 
              </button>
              <button
                className={styles.tab}
                style={{
                  width: '220px',
                  backgroundColor: activeTab === 'Diagnosis' ? 'white' : 'transparent',
                  color: activeTab === 'Diagnosis' ? '#f65e39' : 'black',
                  boxShadow: activeTab === 'Diagnosis' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '',
                }}
                onClick={() => setActiveTab('Diagnosis')}
              >
                {tPGT('pgtResult')}
              </button>
            </div>
            {/* Right side: Add Orders button */}
            {canAdd && !showAddForm && activeTab === 'Test' && (
              <Button variant="contained" color="primary" onClick={handleAddOrders}>
                {tPGT('addOrders')}
              </Button>
            )}
          </Box>
          <Box mt={2}>
            {selectedPatient?.id && activeTab === 'Test' && (
              showAddForm ? (
                <PgtOrderForm onCancel={() => setShowAddForm(false)} />
              ) : (
                <PgtOrders />
              )
            )}
            {selectedPatient?.id && activeTab === 'Diagnosis' && <PgtResult />}
          </Box>
        </Grid2>
      </div>
    </ThemeProvider>
  );
}
